import type { ScanedDetails } from './scannedDetails'

export const extractHvfDetails = (rawOcrResult: string): ScanedDetails | null => {
	try {
		const ocrResults = rawOcrResult.replaceAll('\n', ':').replaceAll(' ', '').split(':')
		const exchange = ocrResults[0]
		const symbol = ocrResults[1]
		const [high_1_price, high_1_time] = ocrResults[2].split('-')
		const [low_1_price, low_1_time] = ocrResults[3].split('-')
		const [high_2_price, high_2_time] = ocrResults[4].split('-')
		const [low_2_price, low_2_time] = ocrResults[5].split('-')
		const [high_3_price, high_3_time] = ocrResults[6].split('-')
		const [low_3_price, low_3_time] = ocrResults[7].split('-')

		return {
			symbol,
			exchange,
			high_1_price: Number(high_1_price),
			high_1_time: Number(+high_1_time),
			high_2_price: Number(high_2_price),
			high_2_time: Number(+high_2_time),
			high_3_price: Number(high_3_price),
			high_3_time: Number(+high_3_time),
			low_1_price: Number(low_1_price),
			low_1_time: Number(+low_1_time),
			low_2_price: Number(low_2_price),
			low_2_time: Number(+low_2_time),
			low_3_price: Number(low_3_price),
			low_3_time: Number(+low_3_time),
		}
	} catch (error) {
		return null
	}
}
